import React from 'react';
import AmazingFeatures from './components/AmazingFeatures';
import CountsComponent from './components/CountsComponent';
import PackagesSwiper from './components/PackagesSwiper';
import DefaultCardsGallery from './components/DefaultCardsGallery';
import HowItWorks from './components/HowItWorks';
import Pricing from './components/Pricing';
import Opportunities from './components/Opportunities';
import ActiveTenderNotifications from './components/ActiveTenderNotifications';
import TailoredAlertSolution from './components/TailoredAlertSolution';
import Header from './components/Header';

function Component() {
  return (
    <>
      <Header page="home" />
      <HowItWorks />
      <Pricing />
      <Opportunities />
      <ActiveTenderNotifications />
      <TailoredAlertSolution />
    </>
  );
}

export default Component;
